export const getColorFromAlias = (alias = '') => {
  // color is included in parens in alias string
  if (!alias?.includes('(')) {
    return '';
  }
  // return what's between the parens
  return alias.substring(alias.indexOf('(') + 1, alias.indexOf(')'));
};
